import { Link } from 'react-router-dom';

const EmptyState = ({ icon = '📭', title, message, actionLabel, actionTo, onAction }) => (
  <div className="empty-state-card">
    <div className="empty-state-icon">{icon}</div>
    {title && <div className="empty-state-title">{title}</div>}
    {message && <div className="empty-state-message">{message}</div>}
    {actionLabel && actionTo && (
      <Link to={actionTo} className="btn btn-primary">{actionLabel}</Link>
    )}
    {actionLabel && onAction && !actionTo && (
      <button className="btn btn-primary" onClick={onAction}>{actionLabel}</button>
    )}
  </div>
);

export default EmptyState;
